import { render, staticRenderFns } from "./rdaccount.vue?vue&type=template&id=64d17ca7&"
import script from "./rdaccount.vue?vue&type=script&lang=js&"
export * from "./rdaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports